import config from '../../constants/config';
import { isEmpty } from './utils';
import URLSearchParams from 'url-search-params';

export function gtmTrack(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function gtmSignupStep(stepName = 'gender', step = 1, totalSteps = 5) {
  gtmTrack({
    event: 'sign_up_interaction',
    step_type: stepName,
    signup_type: 'home',
    step_number: step,
    total_steps: totalSteps,
  });
}

export function gtmTrackAllData(history, user, getConfig) {
  let emailDomain, userId, membership, memberAffiliate, gender;

  if (user && !isEmpty(user)) {
    emailDomain = user.email.split('@')[1];
    userId = `${config.DOMAIN}_${user.user_id}`;
    membership = user.vip_user ? 'VIP' : 'free';

    if (getConfig && getConfig.genders_singular) {
      const genders = getConfig.genders_singular;
      switch (user.sex) {
        case 1:
          gender = genders[1];
          break;
        case 2:
          gender = genders[2];
          break;
        case 3:
          gender = genders[3];
          break;
        default:
          gender = genders[2];
          break;
      }
    }

    if (history.search.includes('aff_id')) {
      const param = new URLSearchParams(history.search);
      memberAffiliate = param.get('aff_id');
    }
  }

  gtmTrack({
    project_id: config.PROJECT,
    website: config.DOMAIN,
    user_id: userId,
    membership,
    email_domain: emailDomain,
    gender,
    member_affiliate: memberAffiliate,
    time_since_reg: undefined,
  });
}
